"use client";

import NotFoundView from "@/components/shared/not-found-view";
import "./globals.css";

export default function GlobalError() {
    return (
        <html lang="en" className="h-full antialiased">
        <body>
        <NotFoundView/>
        </body>
        </html>
    );
}
